import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Button, Form, FormGroup, ControlLabel, FormControl, InputGroup, Glyphicon } from "react-bootstrap";
import Core from "../../Core";

class ChangePasswordPanel extends Component {
  constructor(props) {
    super(props);

    let confirmPassword = "";
    /* Check if the user has a password filled in. This will be filled in if the user is getting created
      Existings users password will be null. Use this to also fill in the confirmpassword field */
    const user = this.props.user;
    if (user && user.Password) confirmPassword = user.Password;

    this.state = {
      confirmPassword: confirmPassword,
      error: null,
    };

    this.Close = this.Close.bind(this);
    this.onError = this.onError.bind(this);
  }

  getUserDetails() {
    return this.props.user;
  }

  onSaveClick() {
    const user = this.getUserDetails();
    if (user) {
      user.Email = user.Email.trim();
      if (user.Password) user.Password = user.Password.trim();
      user.store.storeModel(user, this.Close, this.onError);
    }
  }

  onCancelClick() {
    this.Close();
  }

  Close() {
    window.location.hash = ``;
  }

  onError(id, error) {
    if (error.response && error.response.headers && error.response.headers["x-error-message"]) {
      this.setState({ error: error.response.headers["x-error-message"] });
    }
  }

  onConfirmPasswordChange(key, e) {
    let value = e.target.value;
    if (value === "") value = null;

    this.setState({ confirmPassword: value });
  }

  validatePassword() {
    let validationState = null;

    let currentUser = this.getUserDetails();

    if (currentUser) {
      let newPassword = currentUser.Password;
      if (newPassword === "") newPassword = null;

      let confirmPassword = this.state.confirmPassword;
      if (confirmPassword === "") confirmPassword = null;

      if (newPassword !== confirmPassword) {
        validationState = "error";
      }
    }

    return validationState;
  }

  toggleNewPassword() {
    const input = document.getElementById("newpw");
    this.togglePassword(input);
  }

  toggleConfirmNewPassword() {
    const input = document.getElementById("confirmnewpw");
    this.togglePassword(input);
  }

  togglePassword(input) {
    if (input.type === "password") {
      input.type = "text";
    } else {
      input.type = "password";
    }
  }

  render() {
    const user = this.getUserDetails();

    let errorMessage = null;
    if (this.state.error) errorMessage = <div className="alert alert-danger">{this.state.error}</div>;

    return (
      <div>
        <div className="row">
          <h1>Your password is expired. Please change your password</h1>
        </div>

        <Form className="well">
          <div className="row">
            <FormGroup className="col-sm-4" validationState={this.validatePassword()}>
              <ControlLabel>New password</ControlLabel>
              <Core.Components.Inputs.ButtonInputGroup
                id={"newpw"}
                type={"password"}
                model={user}
                dataMember={"Password"}
                placeholder={"New password"}
                disabled={false}
                glyphicon={"eye-open"}
                onClick={this.toggleNewPassword.bind(this)}
              />
            </FormGroup>
          </div>

          <div className="row">
            <FormGroup className="col-sm-4" validationState={this.validatePassword()}>
              <ControlLabel>New password confirmation</ControlLabel>
              <InputGroup>
                <FormControl
                  id={"confirmnewpw"}
                  value={this.state.confirmPassword}
                  type={"password"}
                  placeholder={"Confirm password"}
                  onChange={this.onConfirmPasswordChange.bind(this, "ConfirmPassword")}
                />
                <InputGroup.Button>
                  <Button onClick={this.toggleConfirmNewPassword.bind(this)} disabled={false}>
                    <Glyphicon glyph={"eye-open"} />
                  </Button>
                </InputGroup.Button>
              </InputGroup>
            </FormGroup>
          </div>

          <div className="row">
            <FormGroup className="col-sm-4">
              <ControlLabel>Last updated</ControlLabel>
              <Core.Components.Inputs.Date model={user} timeFormat={true} dataMember={"LastUpdated"} required={true} readOnly={"readOnly"} />
            </FormGroup>
          </div>

          <div className="row">
            <div className="col-sm-4">{errorMessage}</div>
          </div>

          <div className="row">
            <div className="pull-right">
              <Button bsStyle="primary" onClick={this.onSaveClick.bind(this)}>
                Save
              </Button>
              <Button bsStyle="link" onClick={this.onCancelClick.bind(this)}>
                Cancel
              </Button>
            </div>
          </div>
        </Form>
      </div>
    );
  }
}

export default inject("stores")(observer(ChangePasswordPanel));



// WEBPACK FOOTER //
// ./src/Components/ChangePasswordPanel/ChangePasswordPanel.js